import { ColDef } from "ag-grid-community";
import { getResourceCreationTimeColumnDef } from "../common/getResourceCreationTimeColumnDef";
import { resourceAccountColumnDef } from "../common/resourceAccountColumnDef";
import { resourceTotalSpendColumnDef } from "../common/resourceTotalSpendColumnDef";
import { regionColumnDef } from "../common/regionColumnDef";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";

export const migColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef(),

  resourceAccountColumnDef,

  resourceTotalSpendColumnDef,

  { field: "resource.instances_count", headerName: "Instances" },

  { field: "resource.recommended_size", headerName: "Recommended size" },

  { field: "resource.max_num_replicas", headerName: "Max" },

  { field: "resource.min_num_replicas", headerName: "Min" },

  regionColumnDef,

  getResourceCreationTimeColumnDef("Launch time"),

  taskColumnDef,

  jiraIssuesColumnDef,
];
